import {injectStyleIfTrue} from 'bitmovin-web-ui/src/helpers/stylingHelpers';
import baseVariables from 'bitmovin-web-ui/src/styles/baseVariables/index';
import React, {Component} from 'react';
import styled from 'styled-components';

import CaretDownPath from '../../media/caret_down_gray.svg';
import {Link} from '../globalStyles';
import {HexagonBaseBg, HexagonSize} from '../hexagonIconImage';

import {
  Props as HexagonLeafletProps,
  StyledContent,
  StyledHexagonIconImage,
  StyledRightArrowImgWrapper as StyledCaretImgWrapper,
  StyledWrapper
} from './hexagonLeaflet';

//#region Styled Components

const ExtendedStyledWrapper = styled(StyledWrapper)`
  cursor: pointer;
`;

interface DropdownProps {
  isOpen: boolean;
}
const StyledDropdownContent = styled.div<DropdownProps>`
  display: none;
  flex-direction: column;
  position: absolute;
  bottom: calc(-100% - 0.5rem);
  width: 100%;
  height: 100%;
  border-radius: inherit;
  margin-top: 0.5rem;

  ${({isOpen}) => injectStyleIfTrue(isOpen)`
    display: flex;
  `}
`;

const StyledDropdownLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${baseVariables.colors.white};
  width: 100%;
  min-height: 100%;
  padding: 2rem;
  box-shadow: 0px 1px 4px rgba(16, 87, 131, 0.2);

  &:not(:last-child) {
    border-bottom: solid ${baseVariables.colors.darkBlueGray} 1px;
  }

  &:first-child {
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
  }

  &:last-child {
    border-bottom-left-radius: inherit;
    border-bottom-right-radius: inherit;
  }

  &:hover {
    background-color: ${baseVariables.colors.lightBlueGray};
  }

  > img {
    width: 75%;
  }
`;

//#endregion

export enum Direction {
  Left,
  Right
}

interface DropdownElement {
  logo: string;
  route: string;
}

interface Props extends HexagonLeafletProps {
  dropdownItems: DropdownElement[];
}

interface State {
  isOpen: boolean;
}

class HexagonLeafletDropdown extends Component<Props, State> {
  private wrapperRef;
  public static defaultProps = {
    direction: Direction.Right,
    hexagonSize: HexagonSize.Normal,
    hexagonOverflowPx: 14,
    borderRadius: baseVariables.sizes.borderRadius
  };

  public state = {
    isOpen: false
  };

  public componentDidMount() {
    document.addEventListener('mousedown', event => this.handleClickOutside(event));
  }

  public componentWillUnmount() {
    document.removeEventListener('mousedown', event => this.handleClickOutside(event));
  }

  private toggleDropdown() {
    this.setState({...this.state, isOpen: !this.state.isOpen});
  }

  public handleClickOutside(event) {
    if (this.wrapperRef != undefined && !this.wrapperRef.contains(event.target)) {
      this.setState({...this.state, isOpen: false});
    }
  }

  public render() {
    return (
      <div ref={ref => (this.wrapperRef = ref)}>
        <ExtendedStyledWrapper
          direction={this.props.direction}
          hexagonSize={this.props.hexagonSize}
          hexagonOverflowPx={this.props.hexagonOverflowPx}
          borderRadius={this.props.borderRadius}
          onClick={() => this.toggleDropdown()}>
          <StyledContent
            direction={this.props.direction}
            hexagonSize={this.props.hexagonSize}
            hexagonOverflowPx={this.props.hexagonOverflowPx}>
            {this.props.children}
          </StyledContent>

          <StyledHexagonIconImage
            direction={this.props.direction}
            size={this.props.hexagonSize}
            iconSrc={this.props.hexagonIconSrc}
            baseBg={HexagonBaseBg.BlueOrange}
          />

          {this.props.direction === Direction.Right && (
            <StyledCaretImgWrapper>
              <img src={CaretDownPath} alt="Caret Down" />
            </StyledCaretImgWrapper>
          )}

          <StyledDropdownContent isOpen={this.state.isOpen}>
            {this.props.dropdownItems.map((item, i) => (
              <StyledDropdownLink to={item.route} key={`hexagon-dropdown-item-${i}`}>
                <img src={item.logo} />
              </StyledDropdownLink>
            ))}
          </StyledDropdownContent>
        </ExtendedStyledWrapper>
      </div>
    );
  }
}

export default HexagonLeafletDropdown;
